import { Injectable } from '@angular/core';
import { Navigator } from 'src/app/components/menu/navigator';
import { AppstorageTsService } from '../appstorage/appstorage.ts.service';
import { ConfigService } from '../config/config.service';
import { EventsService } from '../event/event.service';
import { UserSessionService } from '../user-session/user-session.service';
import { UtilsService } from '../utils/utils.service';
import { WebcontentService } from '../webcontent/webcontent.service';
import { LobbyService } from '../lobby/lobby.service';
import { BonusCollectionService } from '../bonus-collection/bonus-collection.service';
import { GameHubControllerService } from '../gameHub/game-hub-controller';
import { GamesService } from "src/app/services/lobby/games.service";
import { NotificationHandlerService } from '../notification-handler/notification-handler.service';

@Injectable({
  providedIn: 'root'
})

export class RedirectService {

  public href: string = "";

  constructor(
    public events: EventsService,
    public navigator: Navigator,
    public utilsService: UtilsService,
    public userSessionService: UserSessionService,
    public webcontentService: WebcontentService,
    public appStorageService: AppstorageTsService,
    public config: ConfigService,
    private lobbyService: LobbyService,
    private gameHubControllerService: GameHubControllerService,
    private gameService: GamesService,
    private bonusCollectionService: BonusCollectionService,
    private notificationHandler: NotificationHandlerService
  ) { 
    this.events.subscribe('event:redeem:promo', (promoCode) => {
      this.deepLinkToPromos(promoCode);
    })
  }

  public checkForRedirects(): any {
    // this.navigator.navigateTo('LoginComponent', { customModalClass: 'crown-modal', animated: false, backdropDismiss: true });
    let url = document.location.href;

    if (url.indexOf('#password_reset') > -1) {
      this.events.publish("event:lobby:hide");
      return this.navigator.navigateTo("PasswordResetComponent");
    }

    if (url.indexOf('#password_forgot') > -1) {
      this.events.publish("event:lobby:hide");
      return this.navigator.navigateTo("ResetPasswordComponent",{ customModalClass: 'crown-modal'});
    }
    if (url.indexOf('shortlink') > -1 && url.indexOf('deep_link_value') > -1) {
      this.notificationHandler.isNotificationHalted = true;
      const urlParams = new URLSearchParams(url);
      const stub = urlParams.get('deep_link_value');
      const deepLinkSub1 = urlParams.get('deep_link_sub1');

      setTimeout(() => {
        this.redirectDeeplinks(stub, deepLinkSub1);  
      }, 1000);
    }

    if (url.indexOf('#game_launch') > -1) {
      this.gameLaunch(url);
    }
  }


  public gameLaunch(url) {
    console.log('Is it Game Launch URL ---', url);
      let authCheckForUser: boolean;
      if (localStorage.getItem('userSession.sessionToken') !== null) {
        authCheckForUser = true;
      } else {
        authCheckForUser = false;
      }
      const pathValue = this.extractPathValue(url);
      console.log('Game Launch Value:', pathValue);
      // const gameObject = { id: null, game_name: null };

      if (pathValue) {
        const [id, game_name] = pathValue.split('/');
        // gameObject.id = id;
        // gameObject.game_name = game_name;
        // console.log('Extracted Game Object:', gameObject);
        if (authCheckForUser) {
          const gameObject = this.gameService.getGameById(id);
          setTimeout(() => {
            return this.gameHubControllerService.launchCasinoGame(gameObject);
          }, 2000);
        } else {
          let isNumber = str => /^\d+$/.test(str);
          if(id && isNumber(id)){
            const gameObject = { id: Number(id), game_name: game_name };
            console.log('Extracted Game Object:', gameObject);
            this.lobbyService.setWaitingGameData(gameObject);
          } else {
            console.log("id is wrong, please check your url");
          }
          return this.navigator.navigateTo("LoginComponent");
        }
      }
  }

  public extractPathValue(url) {
    // Check if the URL contains the fragment '#game_launch'
    const fragmentIndex = url.indexOf('#game_launch');
    if (fragmentIndex !== -1) {
      let pathStartIndex = fragmentIndex + '#game_launch'.length + 1;
      let pathValue = url.substring(pathStartIndex);
      pathValue = decodeURIComponent(pathValue);
      return pathValue;
    }
    return null;
  }

  public navigateBasedOnPathName(): any {
    let pageName = window.location.pathname;

    if (pageName && pageName.indexOf('localhost') > -1) {
      pageName = '/';
    }

    if (!!pageName && pageName != "/" && !~pageName.indexOf('index.html')) {
      pageName = this.utilsService.cleanPathName(pageName);
    }

    let urlParts = pageName.split("/");
    const stub = urlParts[0];

    if (stub == 'launcher') return this.navigator.redirectToCasinoNoHistory();

    if (stub == 'game' && typeof urlParts[1] === 'string') {
      this.webcontentService.updateExternalLink(urlParts[1]);
      this.navigator.toWebview();
      return setTimeout(() => this.navigator.pushHistoryState("game/" + urlParts[1]), 1000);
    };

    //webview page redirect logic
    if (stub == 'c' && typeof urlParts[1] === 'string') {
      this.webcontentService.updateExternalLink(urlParts[1]);
      this.navigator.toWebview();
      return setTimeout(() => this.navigator.pushHistoryState("c/" + urlParts[1]), 1000);
    }

    if (stub == 'login') {
      this.navigator.toCasino();
      return this.navigator.navigateTo('LoginComponent');
    };

    if (stub == ('signup' || 'join')) {
      this.navigator.toCasino();
      return this.navigator.navigateTo('SigninOptionsComponent');
    };
  }

  // //AppsFlyer DeepLink for Mobile Apps
  // checkUserStateSelector(deepLinkPath: any, deepLinkStateName: any){
  //   this.appStorageService.getStardustJurisdiction().then((stardustJurisdictionResponse) => {
  //     const stardustJurisdiction = !!stardustJurisdictionResponse.value
  //             ? stardustJurisdictionResponse.value
  //             : "none";
  //     //If deep_link_sub1 which is deepLinkStateName param is not set 
  //     //than set the user preference for state and then load the deeplink path        
  //     if(stardustJurisdiction == 'none'){
  //       console.log(deepLinkPath)
  //       console.log(deepLinkStateName)
  //       const deepLinkSub1: any = deepLinkStateName ? deepLinkStateName : "NJ";
  //       this.appStorageService.setStardustJurisdiction(deepLinkSub1).then(() => {
  //         this.config.reloadConfig().then(() => {
  //           return setTimeout(() => {
  //             console.log("skin: jurisdiction change ", deepLinkSub1);
  //             this.deepLinkActionForAppsFlyer(deepLinkPath, deepLinkStateName);      
  //           }, 1000);
  //         });
  //       });
  //     } else {
  //       //If deep_link_sub1 which is deepLinkStateName param is different 
  //       //value than user has already state selected then update the preference logic

  //       if(stardustJurisdiction == deepLinkStateName){
  //         this.deepLinkActionForAppsFlyer(deepLinkPath, deepLinkStateName);
  //       } else {
  //         setTimeout(() => {
  //           this.appStorageService.setStardustJurisdiction(deepLinkStateName).then(() => {
  //             this.config.reloadConfig().then(() => {
  //               return setTimeout(() => {
  //                 console.log("skin: jurisdiction change ", deepLinkStateName);
  //                 this.deepLinkActionForAppsFlyer(deepLinkPath, deepLinkStateName);      
  //               }, 1000);
  //             });
  //           });
  //         }, 1000); //Added Timeout to finish the app's default re-directing to selected state
  //       }
  //       //If use has alreday state selector preference then 
  //       //ignore deep_link_sub1 which is deepLinkStateName param value
  //       //this.deepLinkActionForAppsFlyer(deepLinkPath, deepLinkStateName);
  //     }        
  //   })
  // }

  //AppsFlyer DeepLink for Mobile Apps
  public deepLinkActionForAppsFlyer(pageName, deepLinkSub1?): any {

    if (!!pageName && pageName != "/" && !~pageName.indexOf('index.html')) {
      pageName = this.utilsService.cleanPathName(pageName);
    }
    let urlParts = pageName.split("/");
    const stub = urlParts[0];
    const urlParams = urlParts[1];
    console.log(urlParts)
    this.redirectDeeplinks(stub, deepLinkSub1, urlParams);
  }

  public redirectDeeplinks(stub, deepLinkSub1?, urlParams?) {
    //Login componenet Redirect Logic
    if (stub == 'login') {
      this.navigator.toCasino();
      return this.navigator.navigateTo('LoginComponent', { customModalClass: 'crown-modal', animated: false, backdropDismiss: true });
    };

    //Signup componenet Redirect Logic
    if (stub == ('signup' || 'join')) {
      this.navigator.toCasino();
      return this.navigator.navigateTo('SignupOptionsStepOneComponent', { customModalClass: 'crown-modal', animated: false, backdropDismiss: true });
    };

    //game info page redirect logic
    if (stub == 'game' && typeof urlParams === 'string') {
      this.webcontentService.updateExternalLink(urlParams);
      //required timeout bigger number than what is set in the site location service to redirect user to lobby after showing splash page
      return setTimeout(() => {
        this.navigator.toWebview();
        this.navigator.pushHistoryState("game/" + urlParams)
      }, 1500);
    };

    if (stub == 'freecoins') {
        this.notificationHandler.isNotificationHalted = true;
      this.deepLinkToPromos(deepLinkSub1);
      
    };

    //webview page redirect logic
    if (stub == 'c' && typeof urlParams === 'string') {
      this.webcontentService.updateExternalLink(urlParams);
      //required timeout bigger number than what is set in the site location service to redirect user to lobby after showing splash page
      return setTimeout(() => {
        this.navigator.toWebview();
        this.navigator.pushHistoryState("c/" + urlParams)
      }, 1500);
    }
  }
  deepLinkToPromos(promoCode: string) {
    // Navigate to casino first
    this.navigator.toCasino();
  
    setTimeout(() => {
      this.userSessionService.isAuthenticated().then((isAuthenticated) => {
        if (isAuthenticated) {
          this.bonusCollectionService.validateAndNavigateToCollectBonus(promoCode);
        } else {
          this.lobbyService.setPendingBonusCodes(promoCode);
          this.navigator.navigateTo('SignupOptionsStepOneComponent', { 
            customModalClass: 'crown-modal', 
            animated: false, 
            backdropDismiss: true 
          });
        }
      });
    }, 500);
  }
}